import { render, staticRenderFns } from "./EditorMenuBar.vue?vue&type=template&id=ffa7869a&scoped=true&"
import script from "./EditorMenuBar.vue?vue&type=script&lang=js&"
export * from "./EditorMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenuBar.vue?vue&type=style&index=0&id=ffa7869a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa7869a",
  null
  
)

export default component.exports